import axios from 'axios'
import { getAccessToken } from '@/lib/auth/msal'

/** Axios bound to the frozen /api/v1 contract. Dev proxies /api -> localhost:8000. */
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  headers: { 'Content-Type': 'application/json' },
  timeout: 30_000,
})

// Attach the Entra bearer token when authenticated (no-op in demo mode).
api.interceptors.request.use(async (config) => {
  const token = await getAccessToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

export const getJson = async <T>(url: string): Promise<T> => (await api.get<T>(url)).data
